<!--
 * @Description: 广告位表单
 * @Author: fengal
 * @Date: 2023-02-13 9:43:52
-->
<template>
	<el-dialog :title="dialogTitle" :visible.sync="visible"	@open="openDialog" width="960px" center 
		:before-close="handleCloseDialog"	:close-on-click-modal="false" style="text-align: left;" 
		class="dialog-advert">
		<el-form class="advert-form" label-position="top" :model="advert" :rules="rules" ref="advertForm" label-width="40px">
      <el-radio-group v-model="advertType" @change="handleRadioChange" :disabled="operate != 'add'" text-color="#fff" fill="#3E7EF5" 
				style="width: 100%; margin-bottom: 20px; text-align: center;">
        <el-radio-button :label="1" size="mini">本平台广告</el-radio-button>
        <el-radio-button :label="2" size="mini">机构广告</el-radio-button>
      </el-radio-group>
			<el-row :gutter="50" type="flex">
				<el-col :span="8" style="text-align: left">
					<el-form-item label="目标应用：" prop="targetApplicationType">
            <el-select v-model="advert.targetApplicationType" placeholder="请选择目标应用" size="small" style="width: 100%" 
							:disabled="operate != 'add'" @change="handleAppTypeChange">
              <el-option v-for="item in AppOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8" style="text-align: left">
					<el-form-item label="展示位置：" prop="positionKey">
            <el-select v-model="advert.positionKey" clearable filterable placeholder="请选择展示位置" size="small" style="width: 100%;" 
							@change="handlePosChange">
              <el-option v-for="(value, key) in positionOptions" :key="key" :label="value" :value="key" />
            </el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8"  v-if="advertType === 1 && advert.targetApplicationType == 3" style="text-align: left">
					<el-form-item label="名称：" prop="title">
						<el-input style="width: 100%;" v-model.trim="advert.title" maxlength="20" clearable size="small" 
							placeholder="请输入名称">
						</el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8" v-else-if="advertType === 1 && advert.targetApplicationType != 3" style="text-align: left">
					<el-form-item label="所属地区：" prop="areaOptions">
            <el-cascader size="small" v-model="areaOptions" clearable filterable  
            placeholder="请选择所属地区" :options="provinceList" style="width: 100%;"
            :props="{checkStrictly: true, expandTrigger: 'hover', children: 'subRegionList', label: 'name', value: 'id',}">
          </el-cascader>
          </el-form-item>
        </el-col>
				<el-col :span="8" v-else style="text-align: left">
					<el-form-item label="专属机构：" prop="institutionId">
						<el-select v-model="advert.institutionId" clearable filterable placeholder="请选择专属机构" :disabled="operate != 'add'" size="small" style="width: 100%;" >
							<el-option v-for="item in institutionList" :key="item.id" :label="item.name" :value="item.id" />
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row v-if="(advertType === 1 && advert.targetApplicationType != 3) || advertType === 2" :gutter="50" type="flex" style="text-align: left">
				<el-col :span="8" style="text-align: left">
					<el-form-item label="名称：" prop="title">
						<el-input style="width: 100%" v-model.trim="advert.title" maxlength="20" clearable size="small" 
							placeholder="请输入名称">
						</el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8"></el-col>
				<el-col :span="8"></el-col>
			</el-row>
      <el-row style="margin-bottom: 20px;">
        <el-col>轮播图片：<span>（{{photos.length}}/5）</span></el-col>
      </el-row>
			<div style="display: flex; justify-content: space-between; flex-wrap: wrap;">
				<div class="upload-box" v-for="(_item, index) in 5" :key="index" v-show="index < photos.length + 1" @click="handleUpload">
					<el-upload ref="upload" accept="image/jpeg,image/jpg,image/png" :disabled="canUpload"
						:auto-upload="false" action="" :show-file-list="false"
						:on-change="(file, fileList) => {handleImgChange(file, fileList, index)}">
						<img :src="photoPath(photos[index])" style="object-fit: contain" class="upload-img" alt="" />
						<el-image v-show="photos[index]" :src="require('@/assets/syscfg/icon-syscfg-delete.png')" fit="contain" 
							class="icon-del" @click.stop="handleImgDel(index)"></el-image>
						<div class="img-tip">{{imgContent}}</div>
						<el-divider></el-divider>
						<el-button size="mini" plain style="margin-top: 5px;">{{photos[index]?'更换图片':'上传图片'}}</el-button>
					</el-upload>
				</div>
				<div class="upload-box" v-show="photos.length != 2" style="visibility: hidden;"></div>
			</div>
		</el-form>
		<div class="dialog-footer bk-wizard-bottons" >
			<el-button @click="handleCancel('advert')">取 消</el-button>
			<template v-if="operate == 'add'">
				<el-button type="primary" @click="handleSaveClick('advert')">保 存</el-button>
			</template>
			<template v-else>
				<el-button type="primary" @click="handleSaveClick('advert')">保 存</el-button>
			</template>
		</div>
	</el-dialog>
</template>

<script>
import Constant from '@/global/Constant.js'

export default {
	name: "AdvertCfgForm",
	props: ["visible", "operate", "advertId"],

	data() {
		return {
			positionList: [],
			provinceList: [],
			areaOptions: [],
			AppOptions: [],
			institutionList: [],
			positionOptions: [],
			advert: {},
			photos: [],
			advertType: 1,
			advertPictureList: [],
			editPictureNum: 0,

			rules: {
				title: [{required: true, message: '请输入名称', trigger: 'blur'}],
				targetApplicationType: [{required: true, message: '请选择目标应用', trigger: 'blur'}],
				positionKey: [{required: true, message: '请选择展示位置', trigger: 'blur'}],
				institutionId: [{required: true, message: '请选择专属机构', trigger: 'blur'}],
			},
		}
	},

	computed: {
		dialogTitle() {
			if (this.operate == 'edit') return '编辑广告位';
			return '新增广告位';
		},

		photoPath() {
			return function(photo){
				if (typeof photo == 'object') return this.commonUtil.file2Url(photo);
	
				return (photo && typeof photo == 'string') ? this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, photo)
					: require("@/assets/syscfg/img-syscfg-upload.png");
			}
		},

		imgContent() {
			if (this.advert.targetApplicationType == 3) return '建议上传1856 × 1258px的图片，大小不超过5M，支持上传png、jpg、jpeg'
			else if (this.advert.targetApplicationType == 1) return '建议上传375 × 202px的图片，大小不超过5M，支持上传png、jpg、jpeg'
			else if (this.advert.targetApplicationType == 2 && this.advert.positionKey == 'user-main') 
				return '建议上传375 × 220px的图片，大小不超过5M，支持上传png、jpg、jpeg'
			else if (this.advert.targetApplicationType == 2 && this.advert.positionKey == 'user-insmain') 
				return '建议上传375 × 141px的图片，大小不超过5M，支持上传png、jpg、jpeg'
			return '请先选择目标应用和展示位置'
		},

		canUpload() {
			return !(this.advert.targetApplicationType == 1 || this.advert.targetApplicationType == 3 
				|| (this.advert.targetApplicationType == 2 && this.advert.positionKey))
		}
	},

	methods: {
		handleRadioChange() {
			this.$set(this.advert, 'targetApplicationType', '')
			this.$set(this.advert, 'positionKey', '')
			this.clearVaild();
			this.advert = {};
			this.photos = []
			this.areaOptions = []
			this.getAdvertAddDo()
		},

		handleAppTypeChange() {
			this.positionList.forEach(item => {
				if ((item.advertType == this.advertType) && (item.applicationType == this.advert.targetApplicationType))
					this.$set(this, 'positionOptions', item.advertPostionMap)
			})
			this.$set(this.advert, 'positionKey', '')
			this.photos = []
		},

		handlePosChange() {
			if (this.advert.targetApplicationType == 2) this.photos = []
		},

		async openDialog() {
			this.clearData();
			if (this.operate === 'add') {
				await this.getAdvertAddDo()
			} else {
				await this.getAdvertUpdateDo()
			}
		},

		appAndPositionOptions(data) {
			return new Promise((resolve) => {
				this.institutionList = this.advertType === 2 ? data.simpleInstitutionList : []
				this.positionList = data.advertPositionList
					this.AppOptions = []
					let appObj = data.targetApplicationTypeMap
					for (let app in appObj) {
						this.AppOptions.push({
							value: app,
							label: appObj[app]
						});
					}
					resolve()
			})
		},

		getAdvertAddDo() {
			return new Promise((resolve) => {
				const type = this.advertType ? this.advertType : 1;
				let params = {type: type};
        let [header, esParam] = this.encryptionUtil.encryptAndSignAllParams(params,
          Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_GET_ADVERT_DO4ADD,
          param: esParam,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
        this.vueRequest(requestData).then((result) => {
					if (result != null) {
						this.appAndPositionOptions(result.data || {})
						this.provinceList = result.data.provinceList || [];
						resolve()
					}
				})
			})
		},

		getAdvertUpdateDo() {
			return new Promise((resolve) => {
				let params = {id: this.advertId};
        let [header, esParam] = this.encryptionUtil.encryptAndSignAllParams(params,
          Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_GET_ADVERT_DO4UPDATE,
          param: esParam,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
        this.vueRequest(requestData).then((result) => {
			  	if (result != null) {
			  		this.advertType = result.data.advert.type
			  		this.positionList = result.data.advertPositionList
			  		this.advert.targetApplicationType = result.data.targetApplicationType
			  		this.handleAppTypeChange()
			  		this.advert = result.data.advert
			  		this.$set(this.advert, 'targetApplicationType', result.data.targetApplicationType.toString())
			  		this.advertPictureList = JSON.parse(JSON.stringify(result.data.advertPictureList))
			  		this.photos = this.advertPictureList.map(obj => obj.picPath)
			  		this.editPictureNum = this.photos.length
			  		this.provinceList = result.data.provinceList || [];
			  		this.areaOptions = [this.advert.provinceId, this.advert.cityId]
			  		this.appAndPositionOptions(result.data || {})
			  		resolve()
			  	}
			  })
			})
		},

		handleUpload() {
			if (this.canUpload)
				this.$message.error('请先选择目标应用和展示位置')
		},

		handleImgChange(file, _fileList, index) {
			let limitation = {}
			if (this.advert.targetApplicationType == 3) {
				limitation = {
					maxSize: Constant.LIMIT_IMG_SIZE_5,
					maxWidth: 1800.0,
					maxHeight: 0,
					extLimit: {
						limitType: 2,
						minRatio: 0.3,
						minRatioText: '100:30'
					},
					returnData: {}
				};
			} else {
				limitation = {
					maxSize: Constant.LIMIT_IMG_SIZE_5,
					maxWidth: 600.0,
					maxHeight: 0,
					extLimit: {
						limitType: 2,
						minRatio: 0.1,
						minRatioText: '100:10'
					},
					returnData: {}
				};
			}
			this.imgUtil.validateAndCompressImg(file, limitation).then((data) => {
				if (data.errorText && data.errorText.length) {
					this.$message.error(data.errorText);
				} else {
					this.photos[index] = data.file
					this.$forceUpdate()
				}
			})
			console.log(this.photos)
		},

		handleImgDel(index) {
			this.photos.splice(index, 1)
			this.$forceUpdate()
			console.log(this.photos)
		},

		//保存接口调用
		handleSaveClick() {
			this.$refs.advertForm.validate((valid) => {
				if (!valid) return false;
				if (!this.photos.length) {
					this.$message.error('请至少上传1张图片！')
					return false;
				}
				this.dataTransfer();
			})
		},

		async dataTransfer() {
			if (this.areaOptions.length === 2) {
				[this.advert.provinceId, this.advert.cityId] = this.areaOptions;
			} else if (this.areaOptions.length === 1) {
				this.$message.error('请选择所属地级市！');
				return false;
			} else {
				this.advert.provinceId = '';
				this.advert.cityId = '';
				this.advert.province = '';
				this.advert.city = '';
			}

			this.initSubmitData();
		},

		async initSubmitData() {
			const url = (this.operate === 'add') ? Constant.URL_SAVE_ADVERT : Constant.URL_UPDATE_ADVERT;
			const method = (this.operate === 'add') ? 'POST' : 'PUT';

			const form = {...this.advert, type: this.advertType};
			delete form.targetApplicationType;

			let fileMap = new Map();
      let params = {};
			if (this.operate === 'edit') {
				const formVO = {
					advert: { ...form },
					advertPictureList: this.photos.map((item) => {
						if (typeof item === 'string') {
							const idx = this.advertPictureList.findIndex((obj) => obj.picPath === item);
							return this.advertPictureList[idx];
						} else if (typeof item === 'object' && item && item.raw) {
							return { id: 0, picPath: item.name };
						}
					}).filter((item) => item)
				};
				params = {'name': 'advertVO', 'value': {...formVO}};
			} else {
				params = {'name': 'advert', 'value': {...form}};
			}
			let fileList = [];
			this.photos.forEach(item => {
				if (typeof item == 'object' && item && item.raw) {
					fileList.push(item.raw);
				}
			})
			if (fileList.length) fileMap.set('fileLists', fileList);
			await this.submitData(method, url, params, fileMap)
			this.clearData();
			this.$emit("close-dialog", true);
		},

		submitData(method, url, params, fileMap) {
			return new Promise(resolve => {
				let header = this.encryptionUtil.signatureObjectParam(
        	params, Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          url: url,
          method: method,
          contentType: this.commonConst.CNTYPE_JSON,
          header: header,
          param: params,
          files: fileMap
        };
        this.vueRequest(requestData).then(result => {
					if (result != null) {
						resolve()
					}
				})	  
			})
		},

		handleCloseDialog() {
			this.clearData();
			this.$emit("close-dialog", false);
		},

		//取消弹框
		handleCancel(_advert) {
			this.clearData();
			this.$emit("close-dialog", false);
		},

		clearVaild() {
			this.$nextTick(() => {
				this.$refs["advertForm"].clearValidate();
			});
		},

		//清空表单
		clearData() {
			this.clearVaild();
			this.advert = {};
			this.photos = []
			this.areaOptions = []
			this.dvertType = 1
		}
	}
}
</script>

<style scoped>
.advert-form {
	padding: 0 25px;
}
.advert-form >>> .el-radio-button__inner {
  padding: 7px 25px;
	width: 120px;
}
.el-row--flex.is-justify-space-between {
    flex-wrap: wrap;
}
.upload-box {
	position: relative;
  margin-bottom: 40px;
  box-sizing: border-box;
  padding: 10px;
  width: 240px;
  height: 294px;
  color: #657180;
  border: 1px solid #D7DDE5;
  border-radius: 4px;
  text-align: center;
	transition: transform 0.2s ease-out;
}
.upload-box:hover {
	transform: scale(1.05);
}
.img-tip {
	margin-top: 10px;
	height: 40px;
	text-align: left;
	font-size: 12px;
	color: #657180;
}
.upload-box .el-button {
  color: #3E7EF5;
  border: 1px solid #3E7EF5;
}
.upload-box >>> .el-divider--horizontal {
	display: block;
	height: 1px;
	width: 100%;
	margin: 20px 0;
}
.upload-img {
	width: 220px;
	height: 129px;
}
.icon-del {
	position: absolute;
	top: 0;
	right: 0;
	padding: 7px;
	width: 20px;
	height: 20px;
	background: #666666;
	border-radius: 4px;
	opacity: 0.6;
}
.img-tip.el-form-item__content {
  line-height: none;
}
.dialog-footer {
  text-align: center;
}
.advert-form >>> .el-form-item .el-form-item__label {
    float: none;
    display: inline-block;
    text-align: left;
    padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/syscfg/components/AdvertCfgForm.vue